import { until } from '@vueuse/core'

/** Opt-in is completed only after checked registration has verified the same email address. */
export default defineNuxtPlugin({
  name: 'reward-registration',
  setup(nuxtApp) {
    const auth = useAuth()
    if (!auth)
      return
    const registration = useRewardRegistration()
    const rewards = useRewards()
    const drawer = useRewardsDrawer()
    let processing = false
    let attempted = ''
    const attemptKey = () => `${rewards.scope.value}:${JSON.stringify(registration.pending.value)}`

    async function completePending() {
      const intent = registration.pending.value
      const customer = auth.activeCustomer.value
      if (processing || !intent || !customer)
        return
      if (intent.expiresAt <= Date.now()) {
        registration.clear()
        return
      }
      if (intent.consent && intent.consent.email !== customer.emailAddress.trim().toLowerCase())
        return
      const key = attemptKey()
      if (key === attempted)
        return
      attempted = key
      // A referral link (including Google sign-in) is not consent to the programme.
      if (!intent.consent) {
        drawer.open('invite')
        return
      }
      processing = true
      const scope = rewards.scope.value
      const current = () => scope === rewards.scope.value && registration.pending.value === intent && intent.expiresAt > Date.now()
      try {
        if (rewards.busy.value)
          await until(rewards.busy).toBe(false)
        if (!current())
          return
        await rewards.load(true)
        if (!current())
          return
        if (rewards.programme.value?.termsVersion !== intent.consent.termsVersion) {
          registration.clearConsent()
          drawer.open('invite')
          return
        }
        if (!rewards.account.value)
          return
        if (!rewards.account.value.termsAccepted) {
          const accepted = await rewards.acceptTerms()
          if (!accepted || !current())
            return
        }
        if (intent.referralCode) {
          const result = await rewards.attachReferral(intent.referralCode)
          if (!result || !current())
            return
        }
        registration.clear()
      }
      catch {
        if (current()) {
          // Keep the code for an explicit retry. Never retry a failed credit in a loop.
          registration.clearConsent()
          drawer.open('invite')
        }
      }
      finally {
        processing = false
        if (attemptKey() !== key)
          void completePending()
      }
    }

    nuxtApp.hook('app:mounted', () => {
      registration.load()
      watch([rewards.scope, registration.pending], () => {
        void completePending()
      }, { immediate: true })
    })
  },
})
